import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex h-full min-h-0" }
const _hoisted_2 = { class: "fixed inset-0 z-40 flex" }
const _hoisted_3 = { class: "absolute top-0 right-0 -mr-12 pt-2" }
const _hoisted_4 = { class: "hidden xl:flex xl:flex-shrink-0" }
const _hoisted_5 = { class: "flex w-64 flex-col" }
const _hoisted_6 = { class: "flex min-w-0 flex-1 flex-col overflow-hidden" }
const _hoisted_7 = { class: "xl:hidden" }
const _hoisted_8 = { class: "flex items-center justify-between border-b border-gray-900 bg-gray-900 pl-2 pr-4 py-1.5" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = {
  key: 0,
  class: "text-gray-200 text-xs inline-flex gap-1 items-center"
}
const _hoisted_11 = {
  class: "relative z-0 flex-1 overflow-y-auto focus:outline-none xl:order-last",
  "data-surface": ""
}

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { InformationCircleIcon } from '@heroicons/vue/20/solid'
import { EllipsisVerticalIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import AppSidebar from '@/components/AppSidebar.vue'
import Toast from '@/components/neue/Toast.vue'
import { activeTour, useProductTour } from '@/composables/useProductTour'
import { useToast } from '@/composables/useToast'
import { tours } from '@/config/tours'


export default {
  __name: 'StandardLayout',
  setup(__props) {

const store = useStore()
const { visible, message, type, duration, key } = useToast()

const sidebarOpen = ref(false)
tours.forEach(tour => useProductTour(tour))

const closeSidebar = () => {
  if (!activeTour.value) sidebarOpen.value = false
}

const user = computed(() => store.state.loggedInUser)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(visible))
      ? (_openBlock(), _createBlock(Toast, {
          key: _unref(key),
          message: _unref(message),
          type: _unref(type),
          duration: _unref(duration)
        }, null, 8, ["message", "type", "duration"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: sidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-40 xl:hidden",
          onClose: closeSidebar
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "fixed inset-0 bg-gray-600 bg-opacity-75" }, null, -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative flex w-full max-w-xs flex-1 flex-col bg-white focus:outline-none" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                              onClick: _cache[0] || (_cache[0] = $event => (sidebarOpen.value = false))
                            }, [
                              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)),
                              _createVNode(_unref(XMarkIcon), {
                                class: "h-6 w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(AppSidebar, {
                        variant: "mobile",
                        onClose: _cache[1] || (_cache[1] = $event => (sidebarOpen.value = false))
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("div", {
                class: "w-14 flex-shrink-0",
                "aria-hidden": "true"
              }, null, -1))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(AppSidebar, { variant: "desktop" })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "-ml-3 inline-flex h-12 w-12 items-center justify-center rounded-md text-gray-200",
              "data-tour": "menu",
              onClick: _cache[2] || (_cache[2] = $event => (sidebarOpen.value = true))
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)),
              _createVNode(_unref(EllipsisVerticalIcon), {
                class: "h-6 w-6",
                "aria-hidden": "true"
              })
            ]),
            _createVNode(_component_router_link, { to: "/orders" }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  class: "w-20 h-8 text-gray-200 fill-current -ml-2",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "167.01",
                  height: "35",
                  viewBox: "0 0 167.01 35"
                }, [
                  _createElementVNode("path", {
                    d: "M57.24,16.55C59,23,55.3,31.88,45.41,34.43c-7.3,1.88-11.8-1-13.29-6.61C30.41,21.43,33.93,12.57,44.06,10c7.11-1.83,11.66.9,13.18,6.59ZM34.73,27.05c1.28,4.81,5,6.43,10.07,5.12,7.63-2,11.38-9.41,9.92-14.87-1.28-4.81-5.24-6.26-10.19-5C36.76,14.32,33.23,21.45,34.73,27.05Z",
                    transform: "translate(0)"
                  }),
                  _createElementVNode("path", {
                    d: "M57.24,16.55C59,23,55.3,31.88,45.41,34.43c-7.3,1.88-11.8-1-13.29-6.61C30.41,21.43,33.93,12.57,44.06,10c7.11-1.83,11.66.9,13.18,6.59ZM34.73,27.05c1.28,4.81,5,6.43,10.07,5.12,7.63-2,11.38-9.41,9.92-14.87-1.28-4.81-5.24-6.26-10.19-5C36.76,14.32,33.23,21.45,34.73,27.05Z",
                    transform: "translate(0)"
                  }),
                  _createElementVNode("path", {
                    d: "M112.48,13.26a19.73,19.73,0,0,1,.78-2.62c-1.8.14-7.94.18-13.83.18.93-1.86,2.8-5.37,3.91-7.56a19.91,19.91,0,0,1-3.26.33c-1,2-2.74,5.42-3.62,7.23H74.2C75.15,9,77,5.45,78.14,3.25a19.91,19.91,0,0,1-3.26.33c-1,2-2.75,5.42-3.63,7.24-4.48,0-8.42-.1-9.64-.19A15.17,15.17,0,0,1,61,13.3c1.22-.09,4.87-.14,9.15-.14-2.91,6-5.06,10.9-5.06,15.06,0,4,2.09,5.93,6,6,4.38,0,8.66-2.25,13.48-7.79a8.79,8.79,0,0,1-2.33-1.92c-4.09,5.41-7.45,7.22-10.81,7.22-2.49,0-3.75-1.24-3.75-3.92,0-3.44,2-8,5.35-14.63H95.25c-2.91,6-5.06,10.9-5.06,15.06,0,4,2.09,5.93,6,6,4.38,0,8.66-2.25,13.48-7.8a9,9,0,0,1-2.33-1.91c-4.09,5.4-7.46,7.22-10.81,7.22-2.49,0-3.75-1.25-3.75-3.92,0-3.44,2-8,5.35-14.63C104.3,13.11,110.68,13.17,112.48,13.26Z",
                    transform: "translate(0)"
                  }),
                  _createElementVNode("path", {
                    d: "M165.14,26.26a15.38,15.38,0,0,0,1.87,2,22,22,0,0,1-14.37,6c-8.31.56-12.52-3-12.92-8.64-.52-7.45,5-15.25,15.94-16,6.35-.44,9.76,2.35,10,5.87.4,5.71-7,9.08-23.25,9.84.49,4.87,4.2,7,10.7,6.51A17.23,17.23,0,0,0,165.14,26.26ZM142.46,23c14.09-.76,20.54-3.23,20.26-7.2-.19-2.66-2.8-4-7.38-3.67C147.86,12.62,143.11,17.46,142.46,23Z",
                    transform: "translate(0)"
                  }),
                  _createElementVNode("path", {
                    d: "M134.12,24.5c-4.09,5.4-7.45,7.22-10.8,7.22a4.18,4.18,0,0,1-2.29-.6,2.92,2.92,0,0,1-1.32-2.64c0-5.6,8.71-17.17,8.71-23a4.07,4.07,0,0,0-2.44-4A5.8,5.8,0,0,0,123.52,1a17.6,17.6,0,0,0-6.43,1.48,14.08,14.08,0,0,1,1,2.49,12.38,12.38,0,0,1,5.12-1.39c1.84,0,2.41,1.09,2.41,1.91,0,4.64-8.76,16.69-8.76,23.19a4.86,4.86,0,0,0,2.47,4.6l.12.07a7.3,7.3,0,0,0,3.51.93c4.38,0,8.67-2.25,13.49-7.8a8.8,8.8,0,0,1-2.34-1.91",
                    transform: "translate(0)"
                  }),
                  _createElementVNode("path", {
                    d: "M20.84,9.61c-4.68,0-8.7,2.1-11.91,7.8H8.52c2.2-5.14,4.09-10.13,4.09-13.11S11,0,8.12,0A17.8,17.8,0,0,0,1.7,1.48,14.45,14.45,0,0,1,2.72,4,12.18,12.18,0,0,1,7.83,2.58c1.66,0,2.34.72,2.34,2.11,0,3.49-4.47,14-10.17,28.66A12.49,12.49,0,0,1,2.63,34c.83-2,1.57-3.87,2.26-5.56,1.67,3.67,4.06,6.34,8.57,6.34,8.19,0,14.91-9,14.91-17.19,0-4.85-2.6-7.95-7.53-7.95ZM13.51,32.2c-3.21,0-5.39-1.8-7.68-6,4.42-10.85,10.53-14.1,14.7-14.1,3.16,0,4.93,1.75,4.93,5.65,0,6.39-5.34,14.49-12,14.49",
                    transform: "translate(0)"
                  })
                ], -1)
              ]))]),
              _: 1
            })
          ]),
          (user.value?.attributes?.phone_formatted)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(user.value?.attributes?.phone_formatted) + " ", 1),
                _createVNode(_unref(InformationCircleIcon), { class: "h-4 w-4" })
              ])), [
                [_directive_tippy, { content: 'This is your Bottle-assigned phone number', theme: 'light' }]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("main", _hoisted_11, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

}